// extracted by mini-css-extract-plugin
module.exports = {"overlay":"WorkoutVideoOverlay_overlay__2OdOd","confirmationCard":"WorkoutVideoOverlay_confirmationCard__1_f8g"};